import React, { useState } from 'react';
import axios from 'axios';
import { API_HOST } from '../consts';
import { toast } from 'react-toastify';
import ModalResolvedComentario from './ModalResolvedComentario';
import ModalEditComentario from './ModalEditComentario';

const ItemComentario = ({ comentario, avaliacaoItem, api }) => {
	const [isModalResolvidoOpen, setIsModalResolvidoOpen] = useState(false);
	const [isModalEditOpen, setIsModalEditOpen] = useState(false);

	const handleModalResolvido = (value) => {
		setIsModalResolvidoOpen(value);
	}

	const handleModalEdit = (value) => {
		setIsModalEditOpen(value);
	}

	const handleComentarioResolvido = () => {
		const params = { resolvido: !comentario.resolvido }

		axios.patch(`${API_HOST}/avaliacoes/avaliacao_item_comentarios/${comentario.id}/alterar_resolvido`, params)
			.then(() => {
				handleModalResolvido(false);

				return axios
					.get(`${API_HOST}/avaliacoes/avaliacao_item`, {
						params: {
							avaliacao: avaliacaoItem.avaliacao.id
						}
					}).then((response) => {

						const itens = response.data.results || response.data

						api.setValues({
							itens
						})
						toast.success('Status do comentário alterado com sucesso!')
					})
			})
	}

	const handleComentarioText = (text) => {
		if (text && text.length > 60) {
			return text.substring(0, 60) + '...';
		}
		return text;
	};

	return (
		<div className="ml-2 mb-2 card rounded" style={{ width: '100%' }}>
			<div className='card-header d-flex justify-content-between align-items-center pb-2 pt-2'>
				<p className="text-muted p-0 m-0" style={{ fontSize: 13, fontWeight: 600 }}>{`Comentário #${comentario.id}`}</p>
				<div className="d-flex align-items-center" style={{ gap: 4 }}>
					<button
						className="btn p-1"
						onClick={() => handleModalEdit(true)}
						title="Editar comentário"
					>
						<i className="fas fa-pencil-alt" style={{ fontSize: 14 }} />
					</button>
					<button
						className="btn p-1"
						onClick={() => handleModalResolvido(true)}
						title={comentario.resolvido ? 'Marcar como pendente' : 'Marcar como resolvido'}
					>
						<i className={comentario.resolvido ? "fas fa-check-circle" : "fas fa-times-circle"} style={{ fontSize: 14 }}></i>
					</button>
				</div>
			</div>
			<p
				className="card-subtitle text-muted"
				style={{ paddingRight: 20, paddingLeft: 20, marginBottom: 6, fontSize: 12 }}>
				Status:
				<span style={{
					marginLeft: 5,
					fontSize: 11,
					border: '1px solid #ccc',
					borderRadius: 4,
					padding: '2px 6px',
					color: comentario.resolvido ? '#28A745' : '#D9534F',
					backgroundColor: comentario.resolvido ? '#d4edda' : '#f8d7da'
				}}>{comentario.resolvido ? 'Resolvido' : 'Pendente'}
				</span></p>
			<div style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 8 }}>
				<p className="card-title" style={{ marginBottom: 2, fontSize: 11, color: '#666' }}>{`Criado por: ${comentario.criado_por}`}</p>
				<p className="card-title" style={{ marginBottom: 0, fontSize: 11, color: '#666' }}>{`Atualizado por: ${comentario.atualizado_por}`}</p>
			</div>
			<div className="card-body pt-2 pb-2">
				<p className="card-text" style={{ fontSize: 13 }}>{handleComentarioText(comentario.comentario)}</p>
				{comentario.texto_selecionado && (
					<div style={{ marginTop: 8, padding: 6, backgroundColor: '#fffbea', border: '1px solid #f0e68c', borderRadius: 4, fontSize: 11 }}>
						<strong>Trecho marcado:</strong> "{comentario.texto_selecionado}"
						<div style={{ color: '#666', marginTop: 2 }}>
							Posição: {comentario.posicao_inicial} → {comentario.posicao_final}
						</div>
					</div>
				)}
			</div>
			<ModalResolvedComentario isModalOpen={isModalResolvidoOpen} handleModal={handleModalResolvido} handleComentarioResolvido={handleComentarioResolvido} resolvido={comentario.resolvido} />
			<ModalEditComentario isModalOpen={isModalEditOpen} handleModal={handleModalEdit} comentario={comentario} avaliacaoItem={avaliacaoItem} api={api} />
		</div>
	);
}

export default ItemComentario;
